import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {MechanicValidatorCityImprovements} from '@colonist/game-mechanic-validators'
import {CityImprovementTypes, PlayerColor} from '@colonist/game-states'
import {EnumUtils} from '@colonist/utils'
import {UIGameAddAchievementEvent} from '@colonist/ui-game'

export class UIGameMetropolisAchievementController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly cityImprovementsValidator: MechanicValidatorCityImprovements

    private metropolisOwners: Map<CityImprovementTypes, PlayerColor>

    constructor(uiGameManager: UIGameManager, cityImprovementsValidator: MechanicValidatorCityImprovements) {
        this.uiGameManager = uiGameManager
        this.cityImprovementsValidator = cityImprovementsValidator
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.initMetropolisOwners()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CityImprovementStateUpdated: this.playerReceivedMetropolis(); break
            default: break
        }
    }

    private playerReceivedMetropolis() {
        const metropolisType = this.getUpdatedMetropolisType()
        if(metropolisType == undefined) return

        const achievementType = UIGameMetropolisAchievementController.getAchievementType(metropolisType)

        const achievement: UIGameAddAchievementEvent = {
            achievementOwnerNew: this.uiGameManager.gameController.currentState.currentTurnPlayerColor,
            achievementOwnerPrevious: this.metropolisOwners.get(metropolisType),
            achievementType: achievementType,
        }

        this.metropolisOwners.set(metropolisType, achievement.achievementOwnerNew)
        this.uiGameManager.eventController.sendEvent(achievement, UIGameEventEnums.PlayerReceivedAchievement)
    }

    private static getAchievementType(metropolisType: CityImprovementTypes): 'MetropolisTrade' | 'MetropolisPolitics' | 'MetropolisScience' {
        switch(metropolisType) {
            case CityImprovementTypes.Trade: return 'MetropolisTrade'
            case CityImprovementTypes.Politics: return 'MetropolisPolitics'
            case CityImprovementTypes.Science: return 'MetropolisScience'
        }
    }

    private initMetropolisOwners() {
        this.metropolisOwners = new Map<CityImprovementTypes, PlayerColor>()
        EnumUtils.iterateEnum(CityImprovementTypes, (cityImprovementType: CityImprovementTypes) => {
            this.metropolisOwners.set(cityImprovementType, this.cityImprovementsValidator.getPlayerColorOfMetropolisOwner(cityImprovementType) ?? PlayerColor.None)
        })
    }

    private getUpdatedMetropolisType(): CityImprovementTypes | undefined {
        let updatedCityImprovementType: CityImprovementTypes | undefined
        EnumUtils.iterateEnum(CityImprovementTypes, (cityImprovementType: CityImprovementTypes) => {
            for(const player of this.uiGameManager.gameController.getPlayerColors()) {
                const playerDidntHaveMetropolisBefore = this.metropolisOwners.get(cityImprovementType) != player
                const playerHasMetropolis = this.cityImprovementsValidator.getPlayerCityImprovementsStateForType(player, cityImprovementType).hasMetropolis
                if(playerHasMetropolis && playerDidntHaveMetropolisBefore) updatedCityImprovementType = cityImprovementType
            }
        })
        return updatedCityImprovementType
    }
}
